export default "__VITE_ASSET__DOyXUcJb__"